export default "__VITE_ASSET__Upgvd4U___"